/**
 * Vocabulaire fidélité — VERROUILLÉ réseau. Jamais configurable, jamais exposé
 * en contrôle d'interface, identique chez tous les partenaires.
 *
 * Fichier sans dépendance (pas de next/font) : importable par toute app via
 * `@ekaa/tokens/vocabulary`, y compris hors Next.
 */

/** Unité d'un programme marchand (couche 1) — jamais CURRENCY_LABEL sur ces données. */
export const POINTS_LABEL = 'points' as const;

/**
 * Monnaie réseau EKAA (couche 2) — ADR 0024, amendement A1.
 * Capitales, pluriel invariable (« 2 EKORI »), aucun symbole monétaire.
 * Porteur intérimaire : RewardAccount, jusqu'au ledger F0.
 */
export const CURRENCY_LABEL = 'EKORI' as const;

/**
 * Plancher irréductible de signature EKAA : cette mention ne peut jamais être
 * retirée, quel que soit le palier ou le mode. Il n'existe pas d'état « EKAA invisible ».
 */
export const EKAA_SIGNATURE_FLOOR = 'Fidélité opérée par EKAA' as const;
